export default {
  'art.metaTitle': 'Guide débutant du USFans Spreadsheet : Comment rechercher et acheter mieux',
  'art.metaDescription':
    'Nouveau sur USFans ? Ce guide débutant explique le USFans Spreadsheet, comment parcourir les catégories, lire les photos QC, estimer la livraison et utiliser les coupons en toute sécurité.',

  'art.breadcrumbHome': 'Accueil',
  'art.breadcrumbGuides': 'Guides',
  'art.breadcrumbCurrent': 'Guide débutant',

  'art.title': 'Guide débutant du USFans Spreadsheet',
  'art.subtitle': 'Comment rechercher des produits, lire les photos QC et acheter en toute confiance',
  'art.writtenBy': 'Écrit par l\'équipe éditoriale USFans',
  'art.reviewedBy': 'Relu par l\'équipe éditoriale USFans',
  'art.updated': 'Dernière mise à jour',

  'art.intro':
    'Commencer avec USFans peut sembler intimidant. Il y a des liens de produits à ouvrir, des photos QC à vérifier, des options de livraison à comprendre et des détails d\'entrepôt à considérer. Ce guide débutant vous accompagne pas à pas dans le USFans Spreadsheet, pour que vous puissiez rechercher des produits, comprendre le contrôle qualité et prendre des décisions éclairées avant d\'acheter.',

  'art.h1': 'Qu\'est-ce que le USFans Spreadsheet ?',
  'art.p1a':
    'Le USFans Spreadsheet est une ressource organisée qui rassemble des liens de produits, des catégories et des informations d\'achat dans un seul endroit consultable. Au lieu de faire défiler des publications ou messages dispersés, vous pouvez naviguer par catégorie et trouver des articles pertinents plus rapidement.',
  'art.p1b':
    'C\'est un outil de recherche, pas une boutique officielle. Ouvrez toujours les liens, consultez les détails sur le site principal et faites vos propres vérifications avant de finaliser un achat.',

  'art.h2': 'Comment fonctionne le USFans Spreadsheet',
  'art.p2a': 'L\'idée est simple : parcourez une catégorie, ouvrez un lien produit, comparez les options, puis décidez.',
  'art.l21': 'Parcourez des catégories comme Chaussures, Sweats, T-shirts, Vestes et plus.',
  'art.l22': 'Ouvrez un lien produit pour voir tous les détails sur le site principal.',
  'art.l23': 'Comparez des articles similaires avant de décider.',
  'art.l24': 'Utilisez les guides pour comprendre le QC, la livraison et les coupons.',

  'art.h3': 'Comprendre les catégories principales',
  'art.p3a':
    'Le spreadsheet est organisé en catégories claires pour que vous trouviez plus vite ce dont vous avez besoin : Chaussures, Sweats/Pulls, T-shirts, Vestes, Pantalons/Shorts, Couvre-chefs, Ensembles, Sous-vêtements, Maillots, Accessoires, Sacs, Ceintures, Parfums et Autres articles.',
  'art.p3b':
    'Commencez par la catégorie qui correspond à ce que vous cherchez, puis explorez quelques articles avant de restreindre votre choix.',

  'art.h4': 'Comment lire les photos QC',
  'art.p4a':
    'Les photos QC (contrôle qualité) sont des images de l\'article réel avant expédition. Elles vous aident à voir ce que vous recevrez vraiment.',
  'art.l41': 'Vérifiez attentivement les coutures et l\'emplacement du logo.',
  'art.l42': 'Comparez les couleurs et les détails avec la fiche produit.',
  'art.l43': 'Regardez les mesures si elles sont fournies.',
  'art.l44': 'Demandez plus de photos si quelque chose n\'est pas clair.',

  'art.h5': 'Coûts de livraison et ce qui les influence',
  'art.p5a':
    'La livraison peut modifier le coût final d\'une commande. Elle dépend de la destination, du poids du colis, du volume, de la ligne de livraison, de l\'emballage, de l\'assurance et même de la saison.',
  'art.p5b':
    'Les prix varient, alors vérifiez toujours les tarifs actuels et estimez avant de payer plutôt que de supposer un montant fixe.',

  'art.h6': 'Coupons et codes promo',
  'art.p6a':
    'Les coupons et codes promo peuvent vous faire économiser, mais les codes changent souvent. Vérifiez toujours le statut actuel, l\'expiration et les restrictions avant d\'en appliquer un. Si aucun code actif vérifié n\'est disponible, prenez le prix normal comme référence.',

  'art.h7': 'USFans est-il sûr ? Que vérifier',
  'art.l71': 'Vérifiez les liens avant de les ouvrir.',
  'art.l72': 'Vérifiez attentivement les informations du vendeur.',
  'art.l73': 'Protégez votre compte et vos données de paiement.',
  'art.l74': 'Consultez les conditions de livraison et de retour.',
  'art.l75': 'Méfiez-vous des offres suspectes ou trop belles pour être vraies.',

  'art.h8': 'Checklist pour débutants',
  'art.l81': 'Décidez de la catégorie à parcourir.',
  'art.l82': 'Ouvrez et examinez plusieurs liens de produits.',
  'art.l83': 'Vérifiez les photos QC et les mesures.',
  'art.l84': 'Estimez la livraison avant de payer.',
  'art.l85': 'Cherchez un coupon ou une réduction actuelle.',
  'art.l86': 'Confirmez les informations du vendeur et du paiement.',
  'art.l87': 'Consultez les politiques de retour et de remboursement.',
  'art.l88': 'Conservez les traces de votre commande.',

  'art.faqQ1': 'Ai-je besoin d\'un compte pour parcourir le USFans Spreadsheet ?',
  'art.faqA1':
    'Parcourir les catégories et les liens ne nécessite pas de compte. Les achats et fonctions liées au compte sont gérés sur le site principal.',
  'art.faqQ2': 'Le USFans Spreadsheet est-il gratuit ?',
  'art.faqA2':
    'Le spreadsheet lui-même est une ressource informative gratuite. Chaque produit a son propre prix, à vérifier sur le site principal.',
  'art.faqQ3': 'À quelle fréquence le spreadsheet est-il mis à jour ?',
  'art.faqA3':
    'Les mises à jour peuvent varier. Consultez toujours le site principal pour les listes, prix et disponibilités les plus récents.',
  'art.faqQ4': 'Puis-je utiliser le spreadsheet sur mobile ?',
  'art.faqA4': 'Oui, les catégories et liens sont accessibles depuis tout appareil avec un navigateur.',

  'art.conclusion':
    'Le USFans Spreadsheet est un point de départ utile pour la recherche de produits. Parcourez les catégories, ouvrez les liens, vérifiez les photos QC et estimez la livraison, puis rendez-vous sur le site principal pour finaliser votre achat. Pour plus d\'informations, revenez sur notre page d\'accueil pour explorer les guides, avis et ressources de livraison.',
  'art.ctaHome': 'Retour à l\'accueil',
  'art.ctaSpreadsheet': 'Visiter le site principal',
};